// @flow

import React from 'react';
import { connect } from 'react-redux';
import { getNewsShareLabel } from '@leasen_nl/listo/src/store/newsSettings';
import { Container } from '@leasen_nl/listo/src/components/grid';
import { Title, Flex, Wrapper } from './socialMedia.styled';
import Icon from '../icon';

type StateProps = {|
  shareLabel: string,
|};

type IconType = {
  name: string,
  link: string,
};

let currentUrl = '';
if (typeof window !== 'undefined') {
  currentUrl = window.location.href;
}
const icons: IconType[] = [
  {
    name: 'facebook',
    link: `https://www.facebook.com/sharer/sharer.php?u=${currentUrl}`,
  },
  {
    name: 'linkedin',
    link: `https://www.linkedin.com/shareArticle?mini=true&url=${currentUrl}`,
  },
  {
    name: 'twitter',
    link: `https://twitter.com/home?status=${currentUrl}`,
  },
];

const SocialMedia = ({ shareLabel }: StateProps) => (
  <Container>
    <Wrapper>
      <Flex>
        <Title>
          {shareLabel}
        </Title>
        {icons && (
          icons.map((icon: IconType) => <Icon key={icon.name} icon={icon.name} link={`${icon.link}`} />)
        )}
      </Flex>
    </Wrapper>
  </Container>
);


const mapStateToProps = (state: any): StateProps => ({
  shareLabel: getNewsShareLabel(state),
});

export default connect<any, any, StateProps, any, any, any>(mapStateToProps)(SocialMedia);
